export default __webpack_public_path__ + "static/media/search.cc832c0e.png";